import { useCallback, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowNotification } from "../Common/showNotification";

function useDetectImage() {
  const [fetchWrapper] = useFetch();
  const showNotification = useShowNotification();

  const [abortController, setAbortController] = useState(new AbortController());

  const detectImage = useCallback(
    (
      capturedImage,
      timeout_duration,
      plates,
      selectedPlateIndex,
      getPlates,
      setIsLoading,
      setLoadingTip
    ) => {
      setIsLoading(true);
      setLoadingTip("Analyzing Image...");

      let timeout_id = setTimeout(() => {
        abortController.abort("");
        setAbortController(new AbortController());
      }, timeout_duration * 1000);

      fetchWrapper({
        endpoint_url: "image/detectImage",
        abort_controller: abortController,
        params: {
          image_url: capturedImage,
          image_size: { width: 0, height: 0 },
        },
        onSuccess: (fetch_output) => {
          clearTimeout(timeout_id);
          setIsLoading(false);

          if (!("error" in fetch_output)) {
            let data = fetch_output["data"];
            let cloned_plates = JSON.parse(JSON.stringify(plates));
            cloned_plates[selectedPlateIndex] = data;
            getPlates(cloned_plates);
          } else {
            showNotification({
              message: "Failed to analyze image.",
              description: "Please try again later or try on a new image.",
            });
          }
        },
        onResponseError: () => {
          setIsLoading(false);
          showNotification({
            message: "Failed to analyze image.",
            description: "Please try again later or try on a new image.",
          });
        },
        onFetchError: () => {
          setIsLoading(false);
          showNotification({
            message: "Failed to analyze image.",
            description: "Please try again later or try on a new image.",
          });
        },
      });
    },
    [fetchWrapper]
  );

  return { detectImage };
}

export default useDetectImage;
